import { useEffect, useState } from "react";
import { mergeStyleSets } from "@fluentui/react";
import { SourceListItem } from "../../interfaces/SourceListItemObj";

export interface SourceListProps {
  sourceList: SourceListItem[];
}

export const useSourceListPanel = (props: SourceListProps) => {
  const [clonedList, setClonedList] = useState(props.sourceList);

  useEffect(() => {
    setClonedList(props.sourceList);
  }, [props.sourceList]);

  const filterItems = (query: string) => {
    setClonedList(props.sourceList.filter((e) => e.desc.toLowerCase().includes(query)));
  };

  const classNames = mergeStyleSets({
    label: {
      padding: "5px, 0px, 5px, 15px",
    },
    icon: {
      width: "220px",
      height: "100px",
      objectFit: "contain",
    },
    iconWrapper: { margin: "11.5rem auto 1.5rem auto", display: "flex", justifyContent: "center" },
  });

  return {
    clonedList,
    classNames,
    filterItems,
  };
};
